import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {CommonsFacadeService} from "../../state/commons/commons-facade.service";
import {BehaviorSubject, combineLatest, map, Observable} from "rxjs";

require('./loader.component.scss');
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'loader',
  template: '<div *ngIf="isDisplayLoader" class="loader-line"></div>',
})
export class LoaderComponent {

  @Input() isDisplayLoader: boolean = false;

  constructor() {
  }

}
